import { DeferId } from '../types';

export function defer(fn: () => void): DeferId {
  return requestAnimationFrame(fn);
}

export function cancelDefer(deferId: DeferId | null): void {
  if (deferId !== null) {
    cancelAnimationFrame(deferId);
  }
}
